import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import {
  AgxSpacer,
  AgxTypography,
  Icon_Clock,
} from '@urbanx/agx.ui-components2'
import { JSX } from 'react'
import { BlockerLayout } from './BlockerLayout'

interface SettlementPendingBlockerProps {
  task: AutopilotTaskDto
}

export const SettlementPendingBlocker = ({ task }: SettlementPendingBlockerProps): JSX.Element => {
  return (
    <BlockerLayout
      task={task}
      title="Pending Settlement Confirmation"
    >
      <AgxSpacer direction="vertical" contentAlignment="center" gap="spacing-sm">
        <AgxSpacer direction="horizontal" contentAlignment="center" gap="spacing-sm">
          <Icon_Clock width={16} height={16} color="var(--text-tertiary)" />
          <AgxTypography
            id="vendorConfirmation"
            type="body_ui"
            size="small"
            color="var(--text-tertiary)"
          >
            Vendor confirmation received
          </AgxTypography>
        </AgxSpacer>
        <AgxSpacer direction="horizontal" contentAlignment="center" gap="spacing-sm">
          <Icon_Clock width={16} height={16} color="var(--text-tertiary)" />
          <AgxTypography
            id="buyerConfirmation"
            type="body_ui"
            size="small"
            color="var(--text-tertiary)"
          >
            Buyer confirmation received
          </AgxTypography>
        </AgxSpacer>
      </AgxSpacer>
    </BlockerLayout>
  )
}
